import Index from 'src/pages/StockRotations/Index.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/stock_rotations',
    name: 'Lagerbewegungen',
    component: Index,
    meta: auth
  }
]
